import { SimpleTable } from '@app/components/base/SimpleTable';
import { LDateTime } from '@app/components/date/LDateTime';
import { AuditSchedule } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ScheduleMatchStatus } from '../../../../components/schedule/ScheduleMatchStatus';
import {
  scheduleStatusDetailActionsMessage,
  scheduleStatusDetailMatchesMessage,
  scheduleStatusDetailScheduledAtMessage,
  scheduleStatusDetailSchedulesMessage,
} from './schedule-status-spot-messages';
import { ScheduleStatusSpotDetailScheduleActions } from './ScheduleStatusSpotDetailScheduleActions';

interface ScheduleStatusSpotDetailSchedulesProps {
  schedules: AuditSchedule[];
}

/**
 * Programmed times with the match for each schedule on the same row.
 */
export function ScheduleStatusSpotDetailSchedules({
  schedules,
}: ScheduleStatusSpotDetailSchedulesProps) {
  const sorted = [...schedules].sort((a, b) => a.datetime.localeCompare(b.datetime));

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        <FormattedMessage {...scheduleStatusDetailSchedulesMessage} />
      </Typography>
      <SimpleTable
        fixedLayout
        columns={[
          {
            header: {
              content: <FormattedMessage {...scheduleStatusDetailScheduledAtMessage} />,
            },
            headerProps: { sx: { width: '28%', whiteSpace: 'nowrap' } },
            renderCell: (schedule) => ({
              content: <LDateTime value={schedule.datetime} showRelative />,
            }),
          },
          {
            header: {
              content: <FormattedMessage {...scheduleStatusDetailMatchesMessage} />,
            },
            headerProps: { align: 'center', sx: { width: '57%' } },
            renderCell: (schedule) => ({
              content: <ScheduleMatchStatus size="medium" schedule={schedule} />,
              props: { align: 'center' },
            }),
          },
          {
            header: {
              content: <FormattedMessage {...scheduleStatusDetailActionsMessage} />,
            },
            headerProps: { align: 'center', sx: { width: '15%', whiteSpace: 'nowrap' } },
            renderCell: (schedule) => ({
              content: <ScheduleStatusSpotDetailScheduleActions schedule={schedule} />,
              props: { align: 'center' },
            }),
          },
        ]}
        data={sorted}
      />
    </Box>
  );
}
